import { iStoreCaseConfiguration } from '@/Interfaces/storeCaseConfiguration';
import { colors } from '@/Constants/colors';
//http://safe.ru/products/shkaf-instrumentalnyy-ts-1995-120604/?sphrase_id=2282901
// TODO type!
export const tc_1995_120604: Omit<iStoreCaseConfiguration & { name: string }, 'itemsFromApi'> = {
    id: '7d533ed8-2405-4964-9cf2-53e16c475bd2',
    name: '120604',
    selectedCaseModel: 'TC-1995',
    selectedCasePresetId: '100002e4-b79a-401e-86d3-63ed745a0e18',
    blenderName: 'tc_1995',
    colorFrame: colors[0].hex,
    colorFace: colors[1].hex,
    image: 'dist/src/img/presets/image_2.png',
    caseItems : [ {
        id: '810365d8-d10a-4373-a71e-44f0eca6bc6f',
        prototypeId: 'tcd_1800',
        isLeft: false,
    }, {
        id: 'b2b098b8-ba43-4c30-9bfc-be9790c0cf8d',
        prototypeId: 'tcs_50x43',
        indexPositionY: 2,
        isLeft: false,
    }, {
        id: 'f76b0f8a-77b6-473a-b9b5-ef42318a37c5',
        prototypeId: 'tcs_50x43',
        indexPositionY: 2,
        isLeft: true,
    }, {
        id: 'e673e927-78d4-41dc-b93f-6ddf3ef98919',
        prototypeId: 'tcsh_43x47',
        indexPositionY: 9,
        isLeft: false,
    }, {
        id: '8e8642fc-12bf-4894-9449-4092ea31306b',
        prototypeId: 'tcsh_43x47',
        indexPositionY: 9,
        isLeft: true,
    }, {
        id: '3c30886d-cb41-47e5-a4b0-2c0451a16d64',
        prototypeId: 'tcsh_43x47',
        indexPositionY: 18,
        isLeft: false,
    }, {
        id: '0141e8ac-e79b-4d4b-910e-25a26a4e6e73',
        prototypeId: 'tcsh_43x47',
        indexPositionY: 18,
        isLeft: true,
    }, {
        id: '1af74b1f-7aae-4a4f-91a7-67fabd0d395b',
        prototypeId: 'tcsh_43x47',
        indexPositionY: 27,
        isLeft: false,
    }, {
        id: '6034e9ea-f5b6-453f-b35b-da4d4606aa87',
        prototypeId: 'tcsh_43x47',
        indexPositionY: 27,
        isLeft: true,
    }, {
        id: '25b6af32-b992-464f-89aa-28537f5b91af',
        prototypeId: 'tcf_42x45',
        indexPositionY: 0,
        isLeft: false,
    }, {
        id: '39d4a54d-931f-424e-ad9a-688be55f403a',
        prototypeId: 'tcf_42x45',
        indexPositionY: 0,
        isLeft: true,
    }, {
        id: '628fa124-80ab-4942-850c-9e0f8dbc2f28',
        prototypeId: 'tcf_42x45',
        indexPositionY: 1,
        isLeft: false,
    }, {
        id: '984252a8-84de-4504-a24c-cba0ede4a84e',
        prototypeId: 'tcf_42x45',
        indexPositionY: 1,
        isLeft: true,
    },
    ],
    //TODO drawerSeparators count=0
    drawerSeparators: [],
    expandedDrawersPrototypeId: [],
};

//{ 'selectedCaseModel':'AMH-TC-EL','selectedCasePresetId':'e2d6641b-d5d3-4aba-b1a5-161807d3ef08','blenderName':'amh_tc_el','caseItems':[ { 'id':'33d1c7ea-e07f-4796-ac95-12ee7b820ee6','prototypeId':'shi_amh_tc','isLeft':false,'indexPositionY':19,'indexPositionX':0 },{ 'id':'a3fecd3e-6a80-4877-bcc5-0eb8bcd88cb8','prototypeId':'amh_tc_125','isLeft':false,'indexPositionY':10,'indexPositionX':0 },{ 'id':'cac7ec4e-1a62-4707-aee7-325d313e6815','prototypeId':'amh_tc_60','isLeft':false,'indexPositionY':18,'indexPositionX':0 },{ 'id':'c58df84e-8f49-4443-9664-9ae5f43bbaa0','prototypeId':'amh_tc_125','isLeft':false,'indexPositionY':3,'indexPositionX':0 } ],'drawerSeparators':[ { 'prototypeId':'tc_60','drawerPrototypeId':'amh_tc_60','count':1 },{ 'prototypeId':'tc_125','drawerPrototypeId':'amh_tc_125','count':1 } ],'expandedDrawersPrototypeId':[ 'amh_tc_60','amh_tc_125' ],'isCloseDoors':true,'isDecoration':false,'colorFrame':'#999993','colorFace':'#00067F','name':'naaam' };
